import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
} from '@mui/material';
import { Menu as MenuIcon, Person as PersonIcon, ExitToApp as ExitToAppIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useSidebar } from './Layout';

const TopBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { user, logout } = useAuth();
  const { sidebarCollapsed, handleMobileDrawerToggle } = useSidebar();

console.log("user");
  console.log(user);
  const navigate = useNavigate();

  // CSS classes are handled by Layout component

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <AppBar position="fixed" sx={{ 
      width: sidebarCollapsed ? '100%' : { sm: `calc(100% - 240px)` }, 
      marginLeft: sidebarCollapsed ? '0px !important' : { sm: '240px !important' },
      transition: 'all 0.3s ease',
      // Force override with inline styles
      style: {
        marginLeft: sidebarCollapsed ? '0px !important' : '240px !important',
        width: sidebarCollapsed ? '100% !important' : 'calc(100% - 240px) !important',
      },
    }}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleMobileDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton
          size="large"
          edge="end"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          color="inherit"
        >
        <Avatar sx={{ 
          backgroundColor: '#fdd415',
          color: '#4e0159',
          fontWeight: 700
        }}>
          {user?.role==1?'A':"U"}
        </Avatar>
        
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          onClose={handleProfileMenuClose}
        >
          {user?.role == 2 ?
          <MenuItem onClick={() => navigate('/profile')}>
            <ListItemIcon
              sx={{
                backgroundColor: '#fdd415',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 32,
                height: 32,
                mr: 1
              }}
            >
              <PersonIcon fontSize="small" sx={{ color: '#4e0159' }} />
            </ListItemIcon>
            Profile
          </MenuItem>:""}
          <MenuItem onClick={handleLogout}>
            <ListItemIcon
              sx={{
                backgroundColor: '#fdd415',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 32,
                height: 32,
                mr: 1
              }}
            >
              <ExitToAppIcon fontSize="small" sx={{ color: '#4e0159' }} />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar; 